<template>
  <v-container fluid>
    <v-layout calign-center justify-center fill-height>
      <v-card class="elevation-5" width="500">
        <v-form @submit.prevent="createManualAttendanceAndRegisterTemperature()">
          <v-toolbar class="mb-0" dark color="primary">
            <v-toolbar-title>
              {{$t('manual_check_in')}}
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-col cols="12"
                   md="12">
            <v-autocomplete
                v-model="unique_number"
                :items="items"
                chips
                clearable
                outlined
                prepend-icon="mdi-account-child"
                :loading="isLoading"
                :search-input.sync="search"
                :item-text="example"
                item-value="unique_number"
                :placeholder="$t('placeholder_invitados2')"
                :label="$t('estudiantes')"
                :error-messages="errors_unique_number"
                :no-data-text="$t('no_resultados')"
                autocomplete="off"
            >
              <template v-slot:selection="data">
                <v-chip>
                  <v-avatar left>
                    <v-img :src="data.item.avatar"></v-img>
                  </v-avatar>
                  {{ data.item.first_name }} {{data.item.last_name}}
                </v-chip>
              </template>
              <template v-slot:item="data">
                <template v-if="typeof data.item !== 'object'">
                  <v-list-item-content v-text="data.item"></v-list-item-content>
                </template>
                <template v-else>
                  <v-list-item-avatar>
                    <img :src="data.item.avatar">
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>{{ data.item.first_name }} {{data.item.last_name}}</v-list-item-title>
                    <v-list-item-subtitle v-html="data.item.group"></v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </template>
            </v-autocomplete>
            </v-col>
            <v-col cols="12"
                   md="8">
              <v-text-field
                  v-model="temperature"
                  outlined
                  type="number"
                  prepend-icon="mdi-temperature-celsius"
                  name="temperature"
                  :placeholder="$t('temperature')"
                  :label="$t('temperature')"
                  :error-messages="errors_temperature"
                  autocomplete="off"
              ></v-text-field>
            </v-col>
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn
                block
                :loading="loadingSend"
                color="primary"
                type="submit">
              {{$t('enviar')}}
              <br>
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
import {mapGetters, mapState} from "vuex"
import {HTTP} from '@/main.js'
import store from '@/store'


export default {
  name: "manual_check_in",
  data () {
    return {
      unique_number: [],
      entries: [],
      isLoading: false,
      search: null,
      temperature: '',
      errors_temperature: [],
      errors_unique_number: [],
      loadingSend: false,
    }
  },
  computed: {
    ...mapState(['language']),
    ...mapGetters(['getProfile']),
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    computedDateExpirationFormatted () {
      return this.formatDate(this.dateExpiration)
    },
    fields () {
      if (!this.unique_number) return []

      return Object.keys(this.unique_number).map(key => {
        return {
          key,
          value: this.unique_number[key] || 'n/a'
        }
      })
    },
    items () {
      return this.entries.map(entry => {
        const algo = entry.first_name.length > this.descriptionLimit
            ? entry.first_name.slice(0, this.descriptionLimit) + '...'
            : entry.first_name

        return Object.assign({}, entry, { algo })
      })
    }
  },
  watch: {
    isUpdating (val) {
      if (val) {
        setTimeout(() => (this.isUpdating = false), 3000)
      }
    },
    search (val) {
      if (val !== null && val !== undefined) {
        if (val.length > 2) {
          this.isLoading = true
          // Lazily load input items
          HTTP.get('students/filter?search=' + val, {
            headers: {
              'Content-Type': 'application/json',
              'authorization': 'Token ' + store.getters.getToken
            }
          })
          .then(response => {
            if (this.entries.length > 0) {
              for (var i = 0; i < response.data.length; i++) {
                this.entries.push(response.data[i])
              }
            } else {
              this.entries = response.data
            }
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => (this.isLoading = false))
        }
      }
    }
  },
  methods: {
    example: item => item.first_name + ' ' + item.last_name,
    createManualAttendanceAndRegisterTemperature () {
      this.errors_temperature = []
      this.errors_unique_number = []
      this.loadingSend = true
      if (this.unique_number !== undefined && this.unique_number.length === 0) {
        this.unique_number = ''
      }
      HTTP.post('classroom/manual/list/take', {
          unique_number: this.unique_number,
          temperature: this.temperature === '' ? null : parseFloat(this.temperature)
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(ok => {
          console.log(ok)
          this.loadingSend = false
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('registro_exito'))
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loadingSend = false
          if (error.response.status === 400) {
            console.log(error.response.data.temperature)
            if (error.response.data.temperature) {
              this.errors_temperature = error.response.data.temperature
            }
            if (error.response.data.unique_number) {
              this.errors_unique_number = error.response.data.unique_number
            }
          }
        })
    },
    clear () {
      this.errors_unique_number = []
      this.errors_temperature = []
      this.$store.commit('snackbar_change_color', 'success')
      this.$store.commit('snackbar_activate_false')
      this.cleanFields()
    },
    cleanFields () {
      this.unique_number = []
      this.temperature = ''
      this.entries = []
    }
  }
}
</script>

<style scoped>

</style>